import React from 'react';
import { Button } from 'react-bootstrap';
import { useIndicatorsContext } from '../context/indicatorsContext/IndicatorsContext';

const FooterModal = ({ viewHandler }) => {
  const { toggleShowinModal, handleSubmitFormValues } = useIndicatorsContext();

  return (
    <>
      <Button variant="dark" onClick={toggleShowinModal}>
        {viewHandler ? 'Cancelar' : 'Cerrar'}
      </Button>
      {viewHandler ? <Button onClick={handleSubmitFormValues}>Guardar</Button> : null}
    </>
  );
};

export default FooterModal;
